import { customIf, customUnless } from './customization.directive';

export default angular
  .module('customization', [])
  .directive('customIf', customIf)
  .directive('customUnless', customUnless)
  .name;
